export const Price = [
    {
      _id: 0,
      name: "₹0 to 100",
      array: [0, 100],
    },
    {
      _id: 1,
      name: "₹100 to 200",
      array: [100, 200],
    },
    {
      _id: 2,
      name: "₹200 to 300",
      array: [200, 300],
    },
    {
      _id: 3,
      name: "₹300 to 400",
      array: [300, 400],
    },
    {
      _id: 4,
      name: "₹400 to 10000",
      array: [400, 10000],
    },
  ];
  